import Input from "@/components/common/Input";
import Text from "@/components/common/Text";
import { Artwork } from "@/interfaces/artwork.interface";
import { Info } from "lucide-react";
import { Button } from "primereact/button";

interface Props {
  data: Artwork;
}

const ArtworkName = ({ data }: Props) => {
  const value = data.name;
  return (
    <Input className="pointer-events-none border-0" value={value} readOnly />
  );
};

const ArtworkActions = ({
  data,
  onDetails,
}: Props & {
  onDelete?: (artwork: Artwork) => void;
  onDetails?: (artwork: Artwork) => void;
}) => {
  return (
    <div className="flex gap-2">
      <Button
        severity="info"
        outlined
        style={{
          width: 28,
          height: 28,
        }}
        tooltip="Details"
        tooltipOptions={{ position: "top" }}
        icon={<Info size={18} />}
        onClick={() => onDetails?.(data)}
      />
    </div>
  );
};

export { ArtworkName, ArtworkActions };
